import * as React from 'react';
import WhyMinglChecklist from './WhyMinglChecklist';

export default function WhyMingl() {
  return (
    <section className="bg-white ph5-ns ph4 pb6">
      <section className="center" style={{ maxWidth: '1440px' }}>
        <div
          id="learnMore"
          className="pt6 flex items-center justify-around flex-row-l flex-column-reverse-m flex-column-reverse"
        >
          <div className="tl" style={{ flexBasis: '400px' }}>
            <h1 className="mingl-light-black f1"> Why Mingl? </h1>
            <div className="pl3">
              <WhyMinglChecklist text="Share and receive contact information digitally, on your phone." />
              <WhyMinglChecklist text="Remember people with geo-location, timestamps and notes." />
              <WhyMinglChecklist text="Complete control of your contact data." />
              <WhyMinglChecklist text="Refer your colleagues or friends." />
              <WhyMinglChecklist text="Always available and up-to-date." />
            </div>
          </div>
          <div className="w-100 w-80-ns pb5 pb0-l" style={{ flexBasis: '56%' }}>
            <div
              style={{
                backgroundImage: `url("${require('../../../../assets/img/FridaProfileAndQR.png')}"`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                paddingBottom: '88%',
              }}
            />
          </div>
        </div>
      </section>
    </section>
  );
}
